import { GruppeTier } from '../../../../../projects/kiene-core/src/lib/components/gruppe-tier/classes/gruppe-tier';

export class AbholListeDialogInput {
    selectedRows: GruppeTier[] = [];
    datumSimuliert: Date;
}
